document.addEventListener('DOMContentLoaded', function() {
    const tabsItems = document.querySelectorAll('.tabs__header-item');
    tabsItems.forEach(item => {
        item.addEventListener('click', function() {
            if (this.classList.contains('active')) {
                this.classList.remove('active');
            } else {
                this.classList.add('active');
            }
            const contentItem = document.getElementById(this.dataset.tab);
            contentItem.classList.toggle('active');
            const tabsItems = document.querySelectorAll('.tabs__header-item');
            tabsItems.forEach(item => {
                if (item !== this) {
                    item.classList.remove('active');
                    const contentItem = document.getElementById(item.dataset.tab);
                    contentItem.classList.remove('active');
                }
            });
        });
    });
});